import React from 'react';
import useRouteHandle from '../useRouteHandle';
import PageLayout from './PageLayout';

const InternalApp = () => {
  const { routeName, pageLayout = {} } = useRouteHandle();

  return <PageLayout.Root elements={pageLayout} routeName={routeName} />;
};

export default InternalApp;
